<script>
    export let pageTitle
</script>

<div class="container max-w-5xl">
    <div class="shadow-lg mx-4 md:mx-0 my-8 md:my-16">
        <h1 class="p-4 md:p-10 text-navy border-b border-navy">{pageTitle}</h1>
        <div class="p-4 md:p-10">
            <slot/>
        </div>
    </div>
</div>